<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    viewBox="0 0 500 500"
  >
    <defs>
      <clipPath id="freepik--clip-path--inject-1--inject-35">
        <path
          d="M213.93,347.17a25.86,25.86,0,0,1-5.36,11.51c-4.55,5.63-10.71,16.61-11,27.05s-12.33,39.33-11,41.47,13.12,5.09,17.67,5.09c2.39,0,6.35.92,7.93-1.41.09-.13-9.35-5-10-5.47s-5.91-4.17-5.74-4.64c0,0,12.34-33.44,18.5-42s10.71-15,12.58-20.35S231.06,348,231.06,348Z"
          style="fill:#fff;stroke:#2e353a;stroke-linecap:round;stroke-linejoin:round"
        ></path>
      </clipPath>
      <clipPath id="freepik--clip-path-2--inject-1--inject-35">
        <path
          d="M252.68,349.36a25.87,25.87,0,0,1,5,11.68c1.13,7.15,5.17,19.07,12.76,26.26s21,37.43,23.48,37.86c2.91.52,7.35-3.2,9.51-4.71,2.75-1.92,9.06-5.84,10-9.23,1.13-3.9-2.88-1.94-4.57-.68-2.19,1.63-13.12,3-13.12,3S279.13,380,276.89,369.7s-4-18-6.71-23-5.43-9.57-5.43-9.57Z"
          style="fill:#fff;stroke:#2e353a;stroke-linecap:round;stroke-linejoin:round"
        ></path>
      </clipPath>
      <clipPath id="freepik--clip-path-3--inject-1--inject-35">
        <path
          d="M214.29,293.73,205,345a70.74,70.74,0,0,0,13.31,6.66c7.32,2.66,20,2,20,2l5-24.95,2,23.29s9.65,1,16.64-.33,18.3-8.66,18.3-8.66l-22-40.92-5-9.65-38.93-1Z"
          style="fill:#fff;stroke:#2e353a;stroke-miterlimit:10"
        ></path>
      </clipPath>
      <clipPath id="freepik--clip-path-4--inject-1--inject-35">
        <path
          d="M233,175s-3.33-4-5.32-2.33-1.34,6.33,1,8.66,5.33.33,5.33.33,1.33,4.32,3.66,6.32,10.31,3.33,13,1.33,1.66-9.32,1.66-9.32,4.66-2.33,4.33-4-3.67-3-3.67-4.32a18.49,18.49,0,0,0-.33-3V166l-15.3,3.33S235.35,177,233,175Z"
          style="fill:#fff;stroke:#2e353a;stroke-linecap:round;stroke-linejoin:round"
        ></path>
      </clipPath>
    </defs>
    <g id="freepik--background-simple--inject-1--inject-35">
      <path
        d="M436.31,271.6c-6.24-4.82-12.61-9.49-16.36-16.46-19-35.27,20.55-76.53-1.4-114.75C407.41,121,385.44,106.81,364,114.87c-22.85,8.6-44.42,17.58-69,10.47-43-12.46-65.33-70.76-112.17-69.78-38.45.8-81.24,41.3-59,83.33,16.85,31.8,6.32,58.12-32.65,63.6S35.45,254,47,273.77s33.69,40.57,12.63,49.34-28.43,37.28-26.32,57,6.31,27.41,6.31,27.41H443.84s17.05-21.93,19.15-72.36c.92-21.86-3.61-43.27-20.13-58.22C440.77,275.08,438.55,273.33,436.31,271.6Z"
        style="fill:#F44336"
      ></path>
      <path
        d="M436.31,271.6c-6.24-4.82-12.61-9.49-16.36-16.46-19-35.27,20.55-76.53-1.4-114.75C407.41,121,385.44,106.81,364,114.87c-22.85,8.6-44.42,17.58-69,10.47-43-12.46-65.33-70.76-112.17-69.78-38.45.8-81.24,41.3-59,83.33,16.85,31.8,6.32,58.12-32.65,63.6S35.45,254,47,273.77s33.69,40.57,12.63,49.34-28.43,37.28-26.32,57,6.31,27.41,6.31,27.41H443.84s17.05-21.93,19.15-72.36c.92-21.86-3.61-43.27-20.13-58.22C440.77,275.08,438.55,273.33,436.31,271.6Z"
        style="fill:#fff;opacity:0.7000000000000001"
      ></path>
    </g>
    <g id="freepik--Shadow--inject-1--inject-35">
      <ellipse
        cx="245.56"
        cy="432"
        rx="76.5"
        ry="8"
        style="fill:#F44336"
      ></ellipse>
      <ellipse
        cx="245.56"
        cy="432"
        rx="76.5"
        ry="8"
        style="fill:#fff;opacity:0.5"
      ></ellipse>
    </g>
    <g id="freepik--Buildings--inject-1--inject-35">
      <polygon
        points="418.43 365.9 418.43 353.69 404.81 353.69 404.81 330 385.24 330 385.24 233.78 366.52 233.78 366.52 291.94 349.5 291.94 349.5 271.12 326.53 271.12 326.53 324.97 317.17 324.97 317.17 342.2 295.05 342.2 295.05 335.74 301.85 335.74 301.85 332.15 273.77 332.15 273.77 336.46 277.18 336.46 277.18 355.13 262.71 355.13 262.71 319.94 211.66 319.94 211.66 345.07 175.06 345.07 175.06 326.4 161.45 326.4 161.45 347.23 132.52 347.23 132.52 309.17 120.61 309.17 120.61 296.25 99.33 296.25 99.33 355.13 78.06 355.13 78.06 368.05 64.45 368.05 64.45 407.54 444.81 407.54 444.81 365.9 418.43 365.9"
        style="fill:none;stroke:#2e353a;stroke-miterlimit:10"
      ></polygon>
      <rect
        x="103.1"
        y="309"
        width="4.6"
        height="4.6"
        style="fill:#2e353a"
      ></rect>
      <rect
        x="112.68"
        y="309"
        width="4.6"
        height="4.6"
        style="fill:#2e353a"
      ></rect>
      <rect
        x="103.1"
        y="318.59"
        width="4.6"
        height="4.6"
        style="fill:#2e353a"
      ></rect>
      <rect
        x="112.68"
        y="318.59"
        width="4.6"
        height="4.6"
        style="fill:#2e353a"
      ></rect>
      <rect
        x="123.03"
        y="318.59"
        width="4.6"
        height="4.6"
        style="fill:#2e353a"
      ></rect>
      <rect
        x="123.03"
        y="328.17"
        width="4.6"
        height="4.6"
        style="fill:#2e353a"
      ></rect>
      <rect
        x="123.03"
        y="337.76"
        width="4.6"
        height="4.6"
        style="fill:#2e353a"
      ></rect>
      <rect
        x="123.03"
        y="347.34"
        width="4.6"
        height="4.6"
        style="fill:#2e353a"
      ></rect>
      <rect
        x="123.03"
        y="356.93"
        width="4.6"
        height="4.6"
        style="fill:#2e353a"
      ></rect>
      <rect
        x="123.03"
        y="366.52"
        width="4.6"
        height="4.6"
        style="fill:#2e353a"
      ></rect>
      <rect
        x="103.1"
        y="328.17"
        width="4.6"
        height="4.6"
        style="fill:#2e353a"
      ></rect>
      <rect
        x="112.68"
        y="328.17"
        width="4.6"
        height="4.6"
        style="fill:#2e353a"
      ></rect>
      <rect
        x="103.1"
        y="337.76"
        width="4.6"
        height="4.6"
        style="fill:#2e353a"
      ></rect>
      <rect
        x="112.68"
        y="337.76"
        width="4.6"
        height="4.6"
        style="fill:#2e353a"
      ></rect>
      <rect
        x="103.1"
        y="347.34"
        width="4.6"
        height="4.6"
        style="fill:#2e353a"
      ></rect>
      <rect
        x="112.68"
        y="347.34"
        width="4.6"
        height="4.6"
        style="fill:#2e353a"
      ></rect>
      <rect
        x="103.1"
        y="356.93"
        width="4.6"
        height="4.6"
        style="fill:#2e353a"
      ></rect>
      <rect
        x="82.01"
        y="362.3"
        width="4.6"
        height="4.6"
        style="fill:#2e353a"
      ></rect>
      <rect
        x="148.34"
        y="351.94"
        width="4.6"
        height="4.6"
        style="fill:#2e353a"
      ></rect>
      <rect
        x="157.54"
        y="351.94"
        width="4.6"
        height="4.6"
        style="fill:#2e353a"
      ></rect>
      <rect
        x="369.58"
        y="239.21"
        width="4.6"
        height="4.6"
        style="fill:#2e353a"
      ></rect>
      <rect
        x="375.33"
        y="239.21"
        width="4.6"
        height="4.6"
        style="fill:#2e353a"
      ></rect>
      <rect
        x="369.58"
        y="248.8"
        width="4.6"
        height="4.6"
        style="fill:#2e353a"
      ></rect>
      <rect
        x="375.33"
        y="248.8"
        width="4.6"
        height="4.6"
        style="fill:#2e353a"
      ></rect>
      <rect
        x="369.58"
        y="258.39"
        width="4.6"
        height="4.6"
        style="fill:#2e353a"
      ></rect>
      <rect
        x="375.33"
        y="258.39"
        width="4.6"
        height="4.6"
        style="fill:#2e353a"
      ></rect>
      <rect
        x="369.58"
        y="267.97"
        width="4.6"
        height="4.6"
        style="fill:#2e353a"
      ></rect>
      <rect
        x="375.33"
        y="267.97"
        width="4.6"
        height="4.6"
        style="fill:#2e353a"
      ></rect>
      <rect
        x="369.58"
        y="277.56"
        width="4.6"
        height="4.6"
        style="fill:#2e353a"
      ></rect>
      <rect
        x="375.33"
        y="277.56"
        width="4.6"
        height="4.6"
        style="fill:#2e353a"
      ></rect>
      <rect
        x="369.58"
        y="287.14"
        width="4.6"
        height="4.6"
        style="fill:#2e353a"
      ></rect>
      <rect
        x="375.33"
        y="287.14"
        width="4.6"
        height="4.6"
        style="fill:#2e353a"
      ></rect>
      <rect
        x="369.58"
        y="296.73"
        width="4.6"
        height="4.6"
        style="fill:#2e353a"
      ></rect>
      <rect
        x="375.33"
        y="296.73"
        width="4.6"
        height="4.6"
        style="fill:#2e353a"
      ></rect>
      <rect
        x="369.58"
        y="306.32"
        width="4.6"
        height="4.6"
        style="fill:#2e353a"
      ></rect>
      <rect
        x="375.33"
        y="306.32"
        width="4.6"
        height="4.6"
        style="fill:#2e353a"
      ></rect>
      <rect
        x="369.58"
        y="315.9"
        width="4.6"
        height="4.6"
        style="fill:#2e353a"
      ></rect>
      <rect
        x="375.33"
        y="315.9"
        width="4.6"
        height="4.6"
        style="fill:#2e353a"
      ></rect>
      <rect
        x="330.47"
        y="315.9"
        width="4.6"
        height="4.6"
        style="fill:#2e353a"
      ></rect>
      <rect
        x="340.44"
        y="315.9"
        width="4.6"
        height="4.6"
        style="fill:#2e353a"
      ></rect>
      <rect
        x="350.41"
        y="315.9"
        width="4.6"
        height="4.6"
        style="fill:#2e353a"
      ></rect>
      <rect
        x="330.47"
        y="336.61"
        width="4.6"
        height="4.6"
        style="fill:#2e353a"
      ></rect>
      <rect
        x="340.44"
        y="336.61"
        width="4.6"
        height="4.6"
        style="fill:#2e353a"
      ></rect>
      <rect
        x="350.41"
        y="336.61"
        width="4.6"
        height="4.6"
        style="fill:#2e353a"
      ></rect>
      <rect
        x="330.47"
        y="357.31"
        width="4.6"
        height="4.6"
        style="fill:#2e353a"
      ></rect>
      <rect
        x="340.44"
        y="357.31"
        width="4.6"
        height="4.6"
        style="fill:#2e353a"
      ></rect>
      <rect
        x="350.41"
        y="357.31"
        width="4.6"
        height="4.6"
        style="fill:#2e353a"
      ></rect>
      <rect
        x="369.58"
        y="325.49"
        width="4.6"
        height="4.6"
        style="fill:#2e353a"
      ></rect>
      <rect
        x="375.33"
        y="325.49"
        width="4.6"
        height="4.6"
        style="fill:#2e353a"
      ></rect>
      <rect
        x="369.58"
        y="335.07"
        width="4.6"
        height="4.6"
        style="fill:#2e353a"
      ></rect>
      <rect
        x="375.33"
        y="335.07"
        width="4.6"
        height="4.6"
        style="fill:#2e353a"
      ></rect>
      <rect
        x="369.58"
        y="344.66"
        width="4.6"
        height="4.6"
        style="fill:#2e353a"
      ></rect>
      <rect
        x="375.33"
        y="344.66"
        width="4.6"
        height="4.6"
        style="fill:#2e353a"
      ></rect>
      <rect
        x="384.92"
        y="335.07"
        width="4.6"
        height="4.6"
        style="fill:#2e353a"
      ></rect>
      <rect
        x="395.66"
        y="335.07"
        width="4.6"
        height="4.6"
        style="fill:#2e353a"
      ></rect>
      <rect
        x="384.92"
        y="344.28"
        width="4.6"
        height="4.6"
        style="fill:#2e353a"
      ></rect>
      <rect
        x="395.66"
        y="344.28"
        width="4.6"
        height="4.6"
        style="fill:#2e353a"
      ></rect>
      <rect
        x="384.92"
        y="353.48"
        width="4.6"
        height="4.6"
        style="fill:#2e353a"
      ></rect>
      <rect
        x="395.66"
        y="353.48"
        width="4.6"
        height="4.6"
        style="fill:#2e353a"
      ></rect>
      <rect
        x="384.92"
        y="362.68"
        width="4.6"
        height="4.6"
        style="fill:#2e353a"
      ></rect>
      <rect
        x="395.66"
        y="362.68"
        width="4.6"
        height="4.6"
        style="fill:#2e353a"
      ></rect>
      <rect
        x="369.58"
        y="354.25"
        width="4.6"
        height="4.6"
        style="fill:#2e353a"
      ></rect>
      <rect
        x="375.33"
        y="354.25"
        width="4.6"
        height="4.6"
        style="fill:#2e353a"
      ></rect>
      <rect
        x="369.58"
        y="363.83"
        width="4.6"
        height="4.6"
        style="fill:#2e353a"
      ></rect>
      <rect
        x="375.33"
        y="363.83"
        width="4.6"
        height="4.6"
        style="fill:#2e353a"
      ></rect>
      <rect
        x="112.68"
        y="356.93"
        width="4.6"
        height="4.6"
        style="fill:#2e353a"
      ></rect>
      <rect
        x="103.1"
        y="366.52"
        width="4.6"
        height="4.6"
        style="fill:#2e353a"
      ></rect>
      <rect
        x="112.68"
        y="366.52"
        width="4.6"
        height="4.6"
        style="fill:#2e353a"
      ></rect>
      <rect
        x="103.1"
        y="376.1"
        width="4.6"
        height="4.6"
        style="fill:#2e353a"
      ></rect>
      <rect
        x="112.68"
        y="376.1"
        width="4.6"
        height="4.6"
        style="fill:#2e353a"
      ></rect>
      <rect
        x="103.1"
        y="385.69"
        width="4.6"
        height="4.6"
        style="fill:#2e353a"
      ></rect>
      <rect
        x="112.68"
        y="385.69"
        width="4.6"
        height="4.6"
        style="fill:#2e353a"
      ></rect>
      <polyline
        points="359.61 388.57 359.61 407.54 321.27 407.54 321.27 369.82 359.61 369.82 359.61 385.19"
        style="fill:none;stroke:#2e353a;stroke-miterlimit:10"
      ></polyline>
      <polyline
        points="430.17 401.81 430.17 407.54 391.82 407.54 391.82 387.6 399.74 387.6"
        style="fill:none;stroke:#2e353a;stroke-miterlimit:10"
      ></polyline>
      <polyline
        points="404.41 387.6 430.17 387.6 430.17 398.7"
        style="fill:none;stroke:#2e353a;stroke-miterlimit:10"
      ></polyline>
      <polyline
        points="147.56 387.6 174.8 387.6 174.8 407.54 136.45 407.54 136.45 387.6 143.92 387.6"
        style="fill:none;stroke:#2e353a;stroke-miterlimit:10"
      ></polyline>
      <polyline
        points="87.57 387.6 91.21 387.6 91.21 407.54 77.02 407.54 77.02 387.6 84.71 387.6"
        style="fill:none;stroke:#2e353a;stroke-miterlimit:10"
      ></polyline>
      <rect
        x="337.37"
        y="369.82"
        width="6.13"
        height="37.72"
        style="fill:none;stroke:#2e353a;stroke-miterlimit:10"
      ></rect>
      <polyline
        points="295.85 374.95 289.83 374.95 289.83 364.98 310.15 364.98 310.15 374.95 301.31 374.95"
        style="fill:none;stroke:#2e353a;stroke-miterlimit:10"
      ></polyline>
      <rect
        x="164.83"
        y="358.08"
        width="23.39"
        height="8.44"
        style="fill:none;stroke:#2e353a;stroke-miterlimit:10"
      ></rect>
      <rect
        x="175.95"
        y="358.08"
        width="2.3"
        height="49.46"
        style="fill:none;stroke:#2e353a;stroke-miterlimit:10"
      ></rect>
    </g>
    <g id="freepik--Location--inject-1--inject-35">
      <path
        d="M250,57.63a129,129,0,0,0-129,129c0,64.35,119,216,119,216h10s129-144.76,129-216A129,129,0,0,0,250,57.63Zm0,192a63,63,0,1,1,63-63A63,63,0,0,1,250,249.63Z"
        style="fill:#2e353a;stroke:#2e353a;stroke-linecap:round;stroke-linejoin:round"
      ></path>
      <path
        d="M240,57.63a129,129,0,0,0-129,129c0,71.24,129,216,129,216s129-144.76,129-216A129,129,0,0,0,240,57.63Zm0,192a63,63,0,1,1,63-63A63,63,0,0,1,240,249.63Z"
        style="fill:#F44336;stroke:#2e353a;stroke-linecap:round;stroke-linejoin:round"
      ></path>
    </g>
  </svg>
</template>

<script>
export default {
  name: "SearchDesactivateLocation"
};
</script>

<style scoped></style>
